import { Flex, Icon } from '@chakra-ui/react'
import { Th, Tr } from '../../components/Table'
import { IoIosArrowDown } from 'react-icons/io'
import { user } from '../../helpers/user'
import { permissoesUsuariosPropostas } from '../../utils/permissoesUsuariosProposta'
import { useSearchParams } from 'react-router-dom'

export function Columns({ orderBy, ordered }) {
  const [searchParams, setSearchParams] = useSearchParams()

  return (
    <Tr>
      <Th py={2} bgColor="#378BBF" w="75px">
        <Flex justifyContent="center" alignItems="center" gap={1} onClick={() => orderBy('abertura_order', 'date')} cursor="pointer">
          Abertura
          <Icon
            as={IoIosArrowDown}
            transition="transform 0.3s"
            transform={ordered.column === 'abertura_order' && ordered.direction === 'asc' ? 'rotate(180deg)' : 'rotate(0)'}
          />
        </Flex>
      </Th>
      <Th py={2} bgColor="#378BBF" width="130px">
        Proposta
      </Th>
      {permissoesUsuariosPropostas[user.codigo_usuario] && (
        <Th py={2} bgColor="#378BBF" width="100px">
          Consultor
        </Th>
      )}
      <Th py={2} bgColor="#378BBF" width="42px">
        <Flex justifyContent="center" alignItems="center" gap={1} onClick={() => orderBy('desconto_order')} cursor="pointer">
          Desconto
          <Icon
            as={IoIosArrowDown}
            transition="transform 0.3s"
            transform={ordered.column === 'desconto_order' && ordered.direction === 'asc' ? 'rotate(180deg)' : 'rotate(0)'}
          />
        </Flex>
      </Th>
      <Th py={2} bgColor="#378BBF" width="147px">
        Cliente
      </Th>
      <Th py={2} bgColor="#378BBF" width="147px">
        Contato
      </Th>
      <Th py={2} bgColor="#378BBF" w="89px">
        <Flex justifyContent="center" alignItems="center" gap={1} onClick={() => orderBy('valor_verba', 'desc')} cursor="pointer">
          Verba
          <Icon
            as={IoIosArrowDown}
            transform={ordered.column === 'valor_verba' && ordered.direction === 'asc' ? 'rotate(180deg)' : 'rotate(0)'}
            transition="transform 0.3s"
          />
        </Flex>
      </Th>
      <Th py={2} bgColor="#378BBF" w="89px">
        Valor <br /> Proposta
      </Th>
      <Th py={2} bgColor="#378BBF" w="45px">
        <Flex justifyContent="center" alignItems="center" gap={1} onClick={() => orderBy('prazo')} cursor="pointer">
          Prazo
          <Icon
            as={IoIosArrowDown}
            transition="transform 0.3s"
            transform={ordered.column === 'prazo' && ordered.direction === 'asc' ? 'rotate(180deg)' : 'rotate(0)'}
          />
        </Flex>
      </Th>
      <Th py={2} bgColor="#378BBF" w="89px">
        Proposta <br /> Encaminhada
      </Th>
      <Th py={2} bgColor="#378BBF" w="89px">
        Layout Enviado
      </Th>
      <Th py={2} bgColor="#378BBF" w="89px">
        Origem
      </Th>
      <Th py={2} bgColor="#378BBF" w="120px">
        Funil de Vendas
      </Th>
      {searchParams.get('propostas_perdidas') === 's' && <Th>Motivo</Th>}
      <Th bgColor="#378BBF" w="112px">
        Último Contato
      </Th>
      <Th py={2} bgColor="#378BBF" w="90px">
        <Flex justifyContent="center" alignItems="center" gap={1} onClick={() => orderBy('retornar_em_order', 'date')} cursor="pointer">
          Retornar em
          <Icon
            as={IoIosArrowDown}
            transition="transform 0.3s"
            transform={ordered.column === 'retornar_em_order' && ordered.direction === 'asc' ? 'rotate(180deg)' : 'rotate(0)'}
          />
        </Flex>
      </Th>
      <Th py={2} bgColor="#378BBF" w="40px" />
      <Th py={2} bgColor="#378BBF" w="40px" />
    </Tr>
  )
}
